import React from 'react';
import Modal from 'toolbox/src/components/Modal/Modal';
import Flex from 'toolbox/src/components/Flex/Flex';
import HeroIconExclamation from 'toolbox/src/components/HeroIcons/HeroIconExclamation';
import Button from 'components/Button';
import { useConfirm } from 'toolbox';

interface ConfirmationModalProps
  extends Omit<ReturnType<typeof useConfirm>, 'confirm'> {
  title: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isConfirming,
  onConfirm,
  onReject,
  title,
  description,
  cancelText,
  confirmText,
}) => {
  return (
    <Modal open={isConfirming} onClose={onReject}>
      <div className="max-w-md p-4 px-6 bg-white">
        <Flex mx={2} alignItems="center" className="mb-4">
          <HeroIconExclamation className="flex-shrink-0 w-8 h-8 text-gray-500" />
          <h3 className="text-base font-semibold tracking-tight text-gray-700">
            {title}
          </h3>
        </Flex>
        {description && (
          <p className="mb-4 text-sm text-gray-600">
            This action cannot be reversed.
          </p>
        )}
        <Flex mx={2} justifyContent="flex-end">
          <Button className="btn btn-white" onClick={onReject}>
            {cancelText || 'Cancel'}
          </Button>
          <Button className="btn" size="small" onClick={onConfirm}>
            {confirmText || 'Confirm'}
          </Button>
        </Flex>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
